import { Component } from '@angular/core';

@Component({
  selector: 'lgv-admin-main-site',
  templateUrl: './admin-main-site.component.html',
  styleUrls: ['./admin-main-site.component.scss'],
  standalone: false,
})
export class AdminMainSiteComponent {}
